/**
 * Browser tab title for a page that doesn't set its own (QA batch 16,
 * NAV-023: Work, Email, Calendar, Activity Log, Reports and Billing kept the
 * previous page's title). Pages that set their own title still win: their
 * effect runs after this one.
 */
const TITLES: [prefix: string, title: string][] = [
  ["/home", "Home"],
  ["/works", "Work"],
  ["/work/", "Work item"],
  ["/mail", "Email"],
  ["/documents", "Documents"],
  ["/calendar", "Calendar"],
  ["/time", "Time"],
  ["/activity-log", "Activity Log"],
  ["/reports", "Reports"],
  ["/billing", "Billing"],
  ["/notifications", "Notifications"],
  ["/settings", "Settings"],
  ["/contacts", "Contacts"],
  ["/contact/", "Client"],
  ["/organization/", "Client"],
  ["/profile", "Profile"],
  ["/signatures", "E-signatures"],
];

export const fallbackPageTitle = (pathname: string): string | null => {
  const path = (pathname || "/").toLowerCase();
  const hit = TITLES.find(
    ([prefix]) =>
      path === prefix.replace(/\/$/, "") ||
      path.startsWith(prefix.endsWith("/") ? prefix : `${prefix}/`) ||
      path === prefix,
  );
  return hit ? hit[1] : null;
};
